import EventsQueue from "../../gd/manager/delta-handler/events-queue-manager/events-queue"
import Resources from "../resources";
import {EntityType} from "../../gd/const/item";
import {DeltaEvent, DeltaEventMethodType, UpdateAction} from "../../gd/manager/delta-handler/types";
import {resourcesDeltaHandler_checkRelevance} from "./check-relevance/check-relevance";
import {convertMeetingEventToUpdateAction} from "./convert-to-update-action/meeting";
import {convertExpenseEventToUpdateAction} from "./convert-to-update-action/expense";

// const debug = 'ResourcesDeltaHandler'
const debug = false

export default class ResourcesDeltaHandler {

    private resources           : Resources
    private eventsQueue         : EventsQueue

    public entitiesToSubscribe      :  EntityType[]

    constructor(resources:Resources, entitiesToSubscribe: EntityType[]) {

        this.resources              = resources
        this.eventsQueue            = new EventsQueue(this.processQueueEvents)
        this.entitiesToSubscribe    = entitiesToSubscribe

        debug && console.log(debug, "constructor relevanceSettings=", this.resources.relevanceSettings, this.entitiesToSubscribe)

        _.map(this.entitiesToSubscribe, (entityType)=>{
            debug && console.log(debug, "Subscribe to entityType=", entityType)
            gd.modelBus.subscribe(
                entityType,
                this,
                (method: DeltaEventMethodType, data:any, header:any)=>{
                    this.onBusEvent(entityType, method, data, header)
                }
            );
        })
    }

    destructor = () => {
        debug && console.log(debug, "destructor")

        this.eventsQueue.destructor()
        this.resources.relevanceSettings?.destructor()
        gd.modelBus.unsubscribe(this)
    }

    onBusEvent = (name:EntityType, method: DeltaEventMethodType, data:any, header:any) => {
        debug && console.log(debug, "onModelEvent", name, method, data, header)

        // Check RELEVANCE first
        if (!resourcesDeltaHandler_checkRelevance(this.resources, name, method, header, data)) {
            // we don't care about this event as it is not relevant
            // console.log("---> relevance not passed")
            return
        }
        // console.log("---> relevance passed")

        this.eventsQueue.addEvent({name, method, header, data})

    }

    processQueueEvents = async (events: DeltaEvent[]) => {
        debug && console.log(debug, "processQueueEvents events=", events)

        let updateActions : UpdateAction[] = await Promise.all(_.map(events, async (deltaEvent:DeltaEvent)=>{
            switch (deltaEvent.name) {

                case EntityType.MEETING:
                    return convertMeetingEventToUpdateAction(deltaEvent)

                case EntityType.EXPENSE:
                    return convertExpenseEventToUpdateAction(deltaEvent)

                default:
                    console.error("#dkdjiyue ResourcesDeltaHandler - no handler")
                    break
            }
        })) as UpdateAction[]

        updateActions = _.compact(updateActions) // remove all false items

        debug && console.log(debug, "processQueueEvents done updateActions=", updateActions)

        this.resources.processUpdates(updateActions)
    }


}